"use client";

import React, { useEffect, useState, useRef } from "react";
import { ArrowRight, ChartBar, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DominioComercialOrientadoADados() {
  const [isMounted, setIsMounted] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section data-section-id="1184" id="impulsione-seu-negócio-com-tecnologia-líder" ref={parentRef} className="relative min-h-screen w-full overflow-hidden bg-[#1A1A1A] text-white dark flex flex-col items-center justify-center pt-20">
      <div className="absolute inset-0 bg-[#1A1A1A] z-0" />

      <div className="absolute inset-0 z-10 opacity-60 mix-blend-screen pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF006E]/30 via-transparent to-[#FF006E]/10" />
        <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full blur-3xl bg-[#FF006E]/20 animate-pulse" />
        <div className="absolute bottom-1/4 left-1/3 w-96 h-96 rounded-full blur-3xl bg-[#FF006E]/10 animate-pulse" style={{
        animationDelay: '1s'
      }} />
      </div>

      <div className="absolute inset-0 z-20 pointer-events-none opacity-20 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] brightness-100 contrast-150 mix-blend-overlay" />
      
      <div className="absolute inset-0 z-20 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.8)_100%)]" />

      <div className="relative z-30 container mx-auto px-4 flex flex-col items-center text-center h-full justify-center flex-grow pt-10 pb-32">
        
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-[#FF006E]/20 bg-[#FF006E]/5 px-4 py-1.5 text-sm font-medium text-[#FF006E] backdrop-blur-sm animate-in fade-in slide-in-from-bottom-4 duration-1000">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FF006E] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FF006E]"></span>
          </span>
          Consultoria Especialista Linx
        </div>

        <h1 className="max-w-[90vw] md:max-w-[75vw] text-5xl md:text-7xl lg:text-8xl xl:text-[60px] font-bold tracking-tighter text-white leading-[1.1] mb-8 animate-in fade-in zoom-in-95 duration-1000 delay-200 uppercase font-sans">
          Franquia Linx Vila Velha, <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-white/40">Impulsione seu Negócio</span>
        </h1>

        <p className="max-w-[700px] text-lg md:text-xl text-white/80 mb-12 leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-400 font-sans">
          Transforme sua visão empreendedora em uma operação de alta performance. Modelo de negócio validado, suporte estratégico e tecnologia líder para garantir sua lucratividade no varejo.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-600">
          <Button asChild size="lg" className="w-full sm:w-auto h-14 px-10 text-lg rounded-[10px] bg-[#FF006E] text-white hover:bg-[#FF006E]/90 shadow-[0_0_30px_-5px_#FF006E] hover:shadow-[0_0_50px_-10px_#FF006E] transition-all duration-500 border border-[#FF006E]/20">
            <Link to="https://wa.me/5527992826653" newTab>
              FALAR NO WhatsAPP
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          
        </div>
      </div>

      

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-48 z-30 perspective-[1000px] pointer-events-none">
        <div className="w-full h-full bg-[#1A1A1A]/40 backdrop-blur-md border-t border-x border-white/10 rounded-t-[10px] shadow-2xl transform rotate-x-12 translate-y-1/2 opacity-80 mask-image-linear-gradient-to-b">
          <div className="p-6 grid grid-cols-3 gap-6 opacity-50">
            <div className="h-32 rounded-[10px] bg-white/5 border border-white/5 p-4">
               <div className="h-2 w-20 bg-white/10 rounded mb-4" />
               <div className="h-16 w-full bg-gradient-to-t from-[#FF006E]/20 to-transparent rounded-b" />
            </div>
            <div className="h-32 rounded-[10px] bg-white/5 border border-white/5 p-4">
               <div className="h-2 w-20 bg-white/10 rounded mb-4" />
               <div className="flex items-end gap-2 h-16">
                  <div className="w-full bg-[#FF006E]/20 h-[40%] rounded-t" />
                  <div className="w-full bg-[#FF006E]/30 h-[70%] rounded-t" />
                  <div className="w-full bg-[#FF006E]/40 h-[50%] rounded-t" />
               </div>
            </div>
            <div className="h-32 rounded-[10px] bg-white/5 border border-white/5 p-4 hidden md:block">
               <div className="h-2 w-20 bg-white/10 rounded mb-4" />
               <div className="space-y-2">
                  <div className="h-2 w-full bg-white/5 rounded" />
                  <div className="h-2 w-[80%] bg-white/5 rounded" />
                  <div className="h-2 w-[60%] bg-white/5 rounded" />
               </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#1A1A1A] to-transparent" />
      </div>

      <style jsx global>{`
        :root, .dark {
          --fume-bg: hsla(0, 0%, 15%, 0.7);
          --background: var(--fume-bg);
        }
        section,
        .card,
        .popover,
        .modal,
        nav,
        footer,
        header,
        article,
        aside,
        dialog,
        .bg-card,
        .bg-popover,
        .bg-modal,
        .bg-section {
          background-color: var(--fume-bg) !important;
          backdrop-filter: blur(12px);
        }
        div[data-wvc-menu_id="16"] {
          background-color: black !important;
        }
        section *,
        .card *,
        .popover *,
        .modal * {
          color: var(--foreground);
        }
        @keyframes shimmer {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .mask-image-linear-gradient-to-b {
            mask-image: linear-gradient(to bottom, black 0%, transparent 100%);
            -webkit-mask-image: linear-gradient(to bottom, black 0%, transparent 100%);
        }
      `}</style>
    </section>;
}